import { supabase } from "./supabaseClient";

export const fetchQuiz = async (quizId) => {
	try {
		const { data, error } = await supabase
			.from("quizzes")
			.select("*")
			.eq("id", quizId)
			.single();

		if (error) throw error;

		return { data, error };
	} catch (error) {
		console.error("Error fetching questions by category:", error);
		return { data: null, error };
	}
};

export const fetchQuizzesByIds = async (quizIds) => {
	if (!Array.isArray(quizIds) || quizIds.length === 0) {
		return { data: [], error: null };
	}

	try {
		const { data, error } = await supabase
			.from("quizzes")
			.select("*")
			.in("id", quizIds);

		if (error) throw error;

		return { data, error: null };
	} catch (error) {
		console.error("Error fetching quizzes by IDs:", error);
		return { data: null, error };
	}
};
